import { Navigate } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import ErrorPage from "./pages/ErrorPage";
import HomePage from "./pages/HomePage";
import SurveyPage from "./pages/SurveyPage";
import NewSurveyPage from "./pages/NewSurveyPage";
import WorkspacePage from "./pages/WorkspacePage";
import SurveyDefinitionTab from "./features/surveys/SurveyDefinitionTab";
import SurveyResultsTab from "./features/surveys/SurveyResultsTab";
import SurveyEditTab from "./features/surveys/SurveyEditTab";
import NewAudiencePage from "./pages/NewAudiencePage";
import path from "path";
import AudiencePage from "./pages/AudiencePage";
import SettingsPage from "./pages/SettingsPage";
import { SurveyAnalysisTab } from "./features/surveys/SurveyAnalysisTab";
import { ExportTab } from "./features/surveys/ExportTab";

export const routes = [
  {
    path: "/",
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: "",
        element: <Layout />,
        children: [
          {
            path: "/workspaces/:workspaceId",
            element: <WorkspacePage />,
          },
          {
            path: "surveys/:surveyId",
            element: <SurveyPage />,
            children: [
              {
                index: true,
                element: <Navigate to="definition" replace />,
              },
              {
                path: "definition",
                element: <SurveyDefinitionTab />,
              },
              {
                path: "edit",
                element: <SurveyEditTab />,
              },
              {
                path: "results",
                element: <SurveyResultsTab />,
              },
              {
                path: "analysis",
                element: <SurveyAnalysisTab />,
              },
              {
                path: "export",
                element: <ExportTab />,
              },
            ],
          },
          {
            path: "/audiences/:audienceId",
            element: <AudiencePage />,
          },
          {
            path: "newsurvey",
            element: <NewSurveyPage />,
          },
          {
            path: "newaudience",
            element: <NewAudiencePage />,
          },
          {
            path: "/settings",
            element: <SettingsPage />,
          },
        ],
      },
    ],
  },
];
